<template>
  <div class="container-fluid px-0 flex-shrink-0">
    <nav class="navbar-dark bg-primary justify-content-between mb-4 px-4">
      <div class="w-75 mx-auto navbar">
        <router-link class="navbar-brand" to="/">者也专栏组件库</router-link>
        <ul class="list-inline mb-0">
          <li class="list-inline-item"><a href="https://coding.imooc.com/class/449.html" target="_blank" class="btn btn-outline-light my-2">购买课程</a></li>
        </ul>
      </div>
    </nav>
    <router-view></router-view>
  </div>
  <footer class="text-center py-4 text-secondary bg-light mt-auto">
    <small>
      <ul class="list-inline mb-0">
        <li class="list-inline-item">© 慕课网（imooc.com）版权所有 | 津ICP备20000929号-1</li>
        <li class="list-inline-item"><a href="https://coding.imooc.com/class/449.html" target="_blank">购买课程</a></li>
        <li class="list-inline-item"><a href="http://docs.vikingship.xyz/" target="_blank">文档</a></li>
        <li class="list-inline-item"><a href="http://api.vikingship.xyz/" target="_blank">API 在线调试</a></li>
        <li class="list-inline-item"><a href="http://showcase.vikingship.xyz/" target="_blank">组件库演示</a></li>
      </ul>
    </small>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'prismjs/themes/prism-solarizedlight.css'
export default defineComponent({
  name: 'App'
})
</script>
